export default "__VITE_ASSET__KrlqnvjV__"